import { useState, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STREAK_KEY = 'evite_dividas_streak';
const ACTIVITY_KEY = 'evite_dividas_activity';

const todayStr = () => new Date().toISOString().slice(0, 10);
const yesterdayStr = () => new Date(Date.now() - 86400000).toISOString().slice(0, 10);
// Progresso do mês baseado no calendário: dia atual / dias do mês (28/29/30/31)
const monthProgress = () => {
  const now = new Date();
  const diasNoMes = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
  const diaAtual = now.getDate();
  return { dia_atual: diaAtual, dias_no_mes: diasNoMes, progress_pct: Math.min(Math.round((diaAtual / diasNoMes) * 100), 100), goal_days: diasNoMes };
};
const readLocal = (key, fallback) => {
  try { return JSON.parse(localStorage.getItem(key) || 'null') || fallback; } catch (e) { return fallback; }
};

export const useGamification = (isAnonymous) => {
  const [status, setStatus] = useState({ ofensiva_atual: 0, dias_ativos: 0, ...monthProgress() });

  const loadStatus = useCallback(async () => {
    if (isAnonymous) {
      let streakObj = readLocal(STREAK_KEY, null);
      // Ativa a ofensiva desde o primeiro segundo de uso (retenção)
      if (!streakObj) {
        streakObj = { ofensiva_atual: 1, last_active: todayStr() };
        localStorage.setItem(STREAK_KEY, JSON.stringify(streakObj));
      }
      const act = readLocal(ACTIVITY_KEY, { mes: '', dias: [], celebrou: [] });
      const mes = todayStr().slice(0, 7);
      const dias = act.mes === mes ? (act.dias || []) : [];
      setStatus({ ofensiva_atual: streakObj.ofensiva_atual || 0, dias_ativos: dias.length, ...monthProgress() });
    } else {
      try {
        const res = await axios.get(`${API}/gamification/status`, { withCredentials: true });
        setStatus(res.data);
      } catch (e) { /* ignore */ }
    }
  }, [isAnonymous]);

  const recordActivity = useCallback(async ({ total, goal } = {}) => {
    if (isAnonymous) {
      const today = todayStr(), yesterday = yesterdayStr();
      const streakObj = readLocal(STREAK_KEY, { ofensiva_atual: 0, last_active: null });
      let act = readLocal(ACTIVITY_KEY, { mes: '', dias: [], celebrou: [] });
      const last = streakObj.last_active;
      let streak = streakObj.ofensiva_atual || 0;
      if (last === today) streak = streak > 0 ? streak : 1;
      else if (last === yesterday) streak = streak + 1;
      else streak = 1;

      const mes = today.slice(0, 7);
      if (act.mes !== mes) act = { mes, dias: [], celebrou: (act.celebrou || []).filter(k => k.startsWith('streak_')) };
      const dias = act.dias || [];
      if (!dias.includes(today)) dias.push(today);

      let celebrate = null;
      const celebrou = act.celebrou || [];
      if (streak > 0 && streak % 7 === 0 && !celebrou.includes(`streak_${streak}`)) {
        celebrate = { reason: 'streak', dias: streak };
        celebrou.push(`streak_${streak}`);
      }
      if (!celebrate && dias.length >= 7 && goal && typeof total === 'number' && total <= goal) {
        const bk = `budget_${mes}`;
        if (!celebrou.includes(bk)) { celebrate = { reason: 'budget', dias: dias.length }; celebrou.push(bk); }
      }

      localStorage.setItem(STREAK_KEY, JSON.stringify({ ofensiva_atual: streak, last_active: today }));
      localStorage.setItem(ACTIVITY_KEY, JSON.stringify({ mes, dias, celebrou }));
      const newStatus = { ofensiva_atual: streak, dias_ativos: dias.length, ...monthProgress() };
      setStatus(newStatus);
      return { ...newStatus, celebrate };
    }
    try {
      const res = await axios.post(`${API}/gamification/checkin`, {}, { withCredentials: true });
      const { ofensiva_atual, dias_ativos, progress_pct, goal_days, dia_atual, dias_no_mes } = res.data;
      setStatus({ ofensiva_atual, dias_ativos, progress_pct, goal_days, dia_atual, dias_no_mes });
      return res.data;
    } catch (e) { return null; }
  }, [isAnonymous]);

  return { status, loadStatus, recordActivity };
};

export default useGamification;
